import "@shared/assets/styles/common.css"
import "@shared/assets/styles/common.custom.css"

import React, { useEffect, useState } from "react"

import { studioPermissionsApi } from "@shared/apis"
import { StudioPermissions } from "@shared/apis/studioPermissions"
import { MessageSenderProvider, useChatInfo } from "@shared/contexts"
import { useWatchingSchedule } from "@shared/hooks"
import { isDev, isLocal } from "@shared/modules"

import ChattingTerms from "live/components/sidebar/contents/ChattingTerms"
import { useRecoilState, useSetRecoilState } from "recoil"
import { showTermsState } from "streamerChatting/store"

import Chatting from "./Chatting"
import Contents from "./Contents"
import Header from "./Header"

declare global {
  interface Window {
    onhelp: Function
    criteo_q: Array<any>
  }
}

function StreamerChatting() {
  const [studioPermissions, setStudioPermissions] =
    useState<StudioPermissions>()
  const { chatMenu } = useChatInfo()
  const setShowTerms = useSetRecoilState(showTermsState)

  useWatchingSchedule()

  useEffect(() => {
    studioPermissionsApi.status().then(({ data: studioPermissions }) => {
      setStudioPermissions(studioPermissions)
    })
  }, [])

  const handleClose = () => {
    setShowTerms({
      isOpen: false,
      step: 1,
      isStep1Agreed: false,
      isStep2Agreed: false,
    })
  }

  return (
    <>
      <section className="wrap streamer">
        <article className="sideB">
          <Header
            isAllowedBlockChat={
              isLocal || isDev ? true : studioPermissions?.isAllowedBlockChat
            }
          />
          <MessageSenderProvider>
            <div
              className={`contB${chatMenu === "PARTNER" ? " " + chatMenu : ""}`}
            >
              <Chatting />
              <Contents studioPermissions={studioPermissions} />
            </div>
          </MessageSenderProvider>
        </article>
      </section>
      <ChattingTerms onClose={handleClose} />
    </>
  )
}

export default StreamerChatting
